export const removeDuplicates = (input) => {
    const wordsArray = input.split(", ").map(word => word.trim());
    const uniqueWords = [...new Set(wordsArray)];
    return uniqueWords.join(", ");
}
